var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-main",attrs:{"id":`editor${_vm.formData.id}`}},[(_vm.visible)?_c('editor',_vm._g(_vm._b({ref:"editor",attrs:{"init":{
      ..._vm.init,
      content_style: `body { color: ${_vm.personInfo.theme === 'dark' ? '#fff' : '#1F232A'}; padding-left: 16px !important; padding-right: 16px !important; }`,
      placeholder: _vm.placeholder,
    }},on:{"input":_vm.contentChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},'editor',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }